import { DEFAULT_SUBDOMAIN, DEFAULT_TENANT } from './constants';

export class Tenant{

    public subdomain: string = DEFAULT_SUBDOMAIN;
    public tenant: string = DEFAULT_TENANT;

    constructor(){

        this.subdomain = this._getSubdomainFromURL()
        this.tenant = this._getTenantFromURL()

    }

    private _getSubdomainFromURL(): string {

        const firstDotPosition = location.hostname.indexOf('.')
        return location.hostname.slice(0, firstDotPosition)
    
    }
    
    private _getTenantFromURL(): string {

        // .replace(/:\d+/, ""); limpia puerto
    
        const subdomain = this._getSubdomainFromURL()
        const hostnameWithoutSubdomain = location.host.replace(subdomain + '.', "").replace(/:\d+/, "");
    
        // REEVALUAR PREFIX PARA LOS TESTINGS
        // return ENVIRONMENT.platform_prefix ? hostnameWithoutSubdomain.replace(ENVIRONMENT.platform_prefix + '.', '') : hostnameWithoutSubdomain;
        return hostnameWithoutSubdomain;
    
    }

    public getAPIBaseURL( urlBase: string = URL_API ): string{

        return urlBase.replace( DEFAULT_TENANT, this.tenant ).replace(/:\d+/, "");

    }

}